import { setCookie } from 'Functions/cookie';

const switchUnderstoodBtns = document.querySelectorAll('.js-switch-understood');

if (switchUnderstoodBtns.length > 0) {
    switchUnderstoodBtns.forEach((understoodBtn) => {
        understoodBtn.addEventListener('click', () => {
            setCookie('first-visit', '1', 1);

            document.querySelector('.l-base').classList.remove('is-first-visit');
        });
    });
}